import { useEffect, useState } from 'react';
import { api, ApiError } from '../lib/api';

interface Stats {
  users?: number;
  missionaries?: number;
  ayudas?: number;
  ayudas_abiertas?: number;
  gospels_read_total?: number;
  events?: number;
  prayers?: number;
  resources?: number;
  inscriptions?: number;
  contacts?: number;
  [k: string]: number | undefined;
}

const LABELS: Record<string, string> = {
  users: 'Usuarios',
  missionaries: 'Misioneros',
  ayudas: 'Solicitudes de ayuda',
  ayudas_abiertas: 'Ayudas abiertas',
  gospels_read_total: 'Evangelios leídos',
  events: 'Eventos',
  prayers: 'Oraciones',
  resources: 'Recursos',
  inscriptions: 'Inscripciones',
  contacts: 'Contactos',
};

export default function StatsPage() {
  const [stats, setStats] = useState<Stats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const data = await api.get<Stats>('/admin/stats');
        if (alive) setStats(data);
      } catch (err) {
        if (alive) setError(err instanceof ApiError ? err.message : 'No se pudieron cargar las estadísticas');
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  if (loading) return <p className="muted">Cargando estadísticas…</p>;
  if (error) return <div className="alert alert-error">{error}</div>;
  if (!stats) return null;

  const items = Object.keys(LABELS).map(k => ({ key: k, label: LABELS[k], value: stats[k] ?? 0 }));

  return (
    <>
      <h1 className="page-title">Estadísticas</h1>
      <div className="stats-grid">
        {items.map(item => (
          <div key={item.key} className="stat-card">
            <div className="stat-label">{item.label}</div>
            <div className="stat-value">{item.value}</div>
          </div>
        ))}
      </div>
    </>
  );
}
